import { render, staticRenderFns } from "./soldConsignment.vue?vue&type=template&id=22394bc2&scoped=true&"
import script from "./soldConsignment.vue?vue&type=script&lang=js&"
export * from "./soldConsignment.vue?vue&type=script&lang=js&"
import style0 from "./soldConsignment.vue?vue&type=style&index=0&id=22394bc2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22394bc2",
  null
  
)

export default component.exports